import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditContactComponent } from '../edit-contact/edit-contact.component';
import { DeleteContactComponent } from '../delete-contact/delete-contact.component';
import { hasTag } from '../../util/tag-utils';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var ContactComponent = /** @class */ (function () {
    function ContactComponent(_toggleService, _editContactDialog, _deleteContactDialog, _snackBar, _businessManagerService) {
        this._toggleService = _toggleService;
        this._editContactDialog = _editContactDialog;
        this._deleteContactDialog = _deleteContactDialog;
        this._snackBar = _snackBar;
        this._businessManagerService = _businessManagerService;
        this.editModeSet = false;
        this.isAmbassador = false;
        this.isRegionalManager = false;
    }
    ContactComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._toggleService.toggleEmitter.subscribe(function (isOn) { return _this.editModeSet = isOn; });
                        if (!(hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 1:
                        _a.isAmbassador = _d.sent();
                        _d.label = 2;
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 3:
                        _c = (_d.sent());
                        if (!_c) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 4:
                        _c = !(_d.sent());
                        _d.label = 5;
                    case 5:
                        _b.isRegionalManager = _c;
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactComponent.prototype.deleteContact = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            businessID: this.business.id,
            contactID: this.business.contacts[index].id
        };
        var dialogRef = this._deleteContactDialog.open(DeleteContactComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Contact Info', 'Deleted', {
                    duration: 2000
                });
                _this.business.contacts.splice(index, 1);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    ContactComponent.prototype.openEditContactDialog = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            businessID: this.business.id,
            contactID: null,
            isNew: false
        };
        index == null ? dialogConfig.data.isNew = true : dialogConfig.data.contact = this.business.contacts[index];
        dialogConfig.data['busID'] = this.business.id;
        dialogConfig.width = '60%';
        var dialogRef = this._editContactDialog.open(EditContactComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                if (isUpdated.isNew) {
                    _this.business.contacts.push(isUpdated.contact);
                    _this._snackBar.open('Contact Info', 'Added', {
                        duration: 2000
                    });
                }
                else {
                    _this._snackBar.open('Contact Info', 'Updated', {
                        duration: 2000
                    });
                }
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return ContactComponent;
}());
export { ContactComponent };
